import { render } from "./ScrollWrap.vue?vue&type=template&id=aa21c614&scoped=true&ts=true"
import script from "./ScrollWrap.vue?vue&type=script&lang=ts"
export * from "./ScrollWrap.vue?vue&type=script&lang=ts"

import "./ScrollWrap.vue?vue&type=style&index=0&id=aa21c614&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/ecom_ecom-offical-website_node_sharelib_cicd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa21c614"]])

export default __exports__